import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ToastContainer from './common/ToastContainer';
import { useToast } from '../hooks/useToast';
import { useTheme } from '../contexts/ThemeContext';

export default function Layout() {
  const { toasts, show: showToast } = useToast();
  const { theme } = useTheme();

  return (
    <div className={`min-h-screen flex flex-col ${
      theme === 'dark' ? 'bg-gray-900' : 'bg-gray-50'
    }`}>
      <Header />
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <Outlet context={{ showToast }} />
      </main>
      <Footer />
      <ToastContainer
        toasts={toasts}
        onClose={(id) => {
          const index = toasts.findIndex(t => t.id === id);
          if (index !== -1) {
            toasts.splice(index, 1);
          }
        }}
      />
    </div>
  );
}